import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vendor-assessment',
  templateUrl: './vendor-assessment.component.html',
  styleUrls: ['./vendor-assessment.component.scss']
})
export class VendorAssessmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
